import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { assetContitionColumn, assetContitionRows, assetOtherData, assetOtherDataRows, employeeListColumn, employeeListRows } from '../../../datatablesource'
import newRequest from '../../../utils/newRequest';
import Datatable from '../../datatable/Datatable'
import "./assetOtherData.scss";
import { useTranslation } from "react-i18next";

const AssetOtherData = ({ component }) => {
    const navigate = useNavigate();
  const { t, i18n } = useTranslation();
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isAuthenticating, setIsAuthenticating] = useState(true);
    const [assetConditionList, setAssetConditionList] = useState([]);
    const [employeeList, setEmployeeList] = useState([]);
    const [otherAssetsCities, setOtherAssetsCities] = useState([]);
     const [isLoading, setIsLoading] = useState(false);

    const fetchAssetConditions = async () => {
        const response = await newRequest.get("/GetAllAssetCondition");
        setAssetConditionList(response.data);
    };

    const fetchEmployeeList = async () => {
        const response = await newRequest.get("/GetAllEmployeeList");
        setEmployeeList(response.data);
    };

    const fetchCities = async () => {
        const response = await newRequest.get("/GetAllCity");
        const getRegionName = await newRequest.get("/GetAllRegion");
        const regionsArray = Array.isArray(getRegionName?.data) ? getRegionName.data : [];
        const regionMap = new Map(
            regionsArray.map((r) => [r.RegionCode, r.RegionName])
        );
        const citiesWithRegion = response.data.map((item) => ({
            ...item,
            RegionName: regionMap.get(item.RegionCode) ?? ""
        }));
        setOtherAssetsCities(citiesWithRegion);
    };

    useEffect(() => {
        setIsLoading(true);
        const fetchData = async () => {
            try {
                switch (component) {
                    case "assetConditon":
                        await fetchAssetConditions();
                        break;
                    case "employeeList":
                        await fetchEmployeeList();
                        break;
                    case "otherAssetsCities":
                        await fetchCities();
                        break;
                    default:
                        await fetchAssetConditions();
                        break;
                }
                setIsAuthenticated(true);
                setIsAuthenticating(false);
                 setIsLoading(false);
            }
            catch (error) {
                console.log(error);
                setIsAuthenticated(false);
                setIsAuthenticating(false);
                navigate("/admin-login");
                 setIsLoading(false);
            }
        };
        fetchData();
    }, [component, navigate]);

    let ComponentTORender;
    switch (component) {
        case "assetConditon":
            ComponentTORender = (
              <Datatable
                secondaryColor="secondary"
                columnsName={assetContitionColumn(t)}
                loading={isLoading}
                data={assetConditionList}
                title={t("ASSET CONDITION")}
                uniqueId="assetConditionId"
                addNewNavigation="/admin/database-config/other-assets-condition/add-new"
                deleteBtnEndPoint="/DeleteAssetConditionById"
                checkboxSelectionOption={false}
                onImportSuccess={fetchAssetConditions}
              />
            );
            break;
        case "employeeList":
            ComponentTORender = (
              <Datatable
                secondaryColor="secondary"
                columnsName={employeeListColumn(t)}
                loading={isLoading}
                data={employeeList}
                title={t("EMPLOYEES LIST")}
                uniqueId="employeeListId"
                addNewNavigation="/admin/database-config/employee-list/add-new"
                deleteBtnEndPoint="/DeleteEmployeeListById"
                checkboxSelectionOption={false}
                onImportSuccess={fetchEmployeeList}
              />
            );
            break;
        case "otherAssetsCities":
            ComponentTORender = (
              <Datatable
                secondaryColor="secondary"
                columnsName={assetOtherData(t)}
                loading={isLoading}
                data={otherAssetsCities}
                title={t("ASSET OTHER DATA")}
                uniqueId="otherAssetsCitiesId"
                addNewNavigation="/admin/database-config/other-assets-cities/add-new"
                deleteBtnEndPoint="/DeleteCityById"
                checkboxSelectionOption={false}
                onImportSuccess={fetchCities}
              />
            );
            break;
        default:
            ComponentTORender = (
              <Datatable
                secondaryColor="secondary"
                columnsName={assetContitionColumn(t)}
                loading={isLoading}
                data={assetConditionList}
                title={t("ASSET CONDITION")}
              />
            );
            break;
    }

    return (
        <>
            {isAuthenticating ? (
                <div>{t("Loading...")}</div>
            ) : isAuthenticated ? (
                <div>
                    {ComponentTORender}
                </div>
            ) : (
                <div>{t("Not authenticated")}</div>
            )}
        </>
    )
}

export default AssetOtherData
